'use client';

import { Group, Stack, Text } from '@mantine/core';
import { Avatar } from '@/components/Avatar';
import { useEffect, useState } from 'react';
import classes from './MobileApplicationHeader.module.css';

interface MobileApplicationHeaderProps {
  mentorUser: any;
}

export default function MobileApplicationHeader({ mentorUser }: MobileApplicationHeaderProps) {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Only track scroll on mobile
      if (window.innerWidth <= 768) {
        setIsScrolled(window.scrollY > 10);
      }
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  return (
    <div className={`${classes.stickyHeader} ${isScrolled ? classes.scrolled : ''}`}>
      <h1 className={classes.title}>Applying for mentorship with:</h1>
      
      <Group gap="xs" wrap="nowrap" align="center">
        <Avatar
          userId={mentorUser.id}
          avatarId={mentorUser.avatarId}
          size={40}
        />
        
        <Stack gap={2} style={{ flex: 1, minWidth: 0, textAlign: 'left' }}>
          <Text size="sm" fw={600} truncate style={{ textAlign: 'left' }}>
            {mentorUser.name}
          </Text>
          {(mentorUser.mentor?.professionalTagline || mentorUser.mentor?.bio) && (
            <Text size="xs" c="dimmed" fs="italic" truncate style={{ textAlign: 'left', lineHeight: 1.2 }}>
              {mentorUser.mentor?.professionalTagline || mentorUser.mentor?.bio}
            </Text>
          )}
        </Stack>
      </Group>
    </div>
  );
}
